import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrackCards from "@/components/TrackCards";
import DonationSection from "@/components/DonationSection";
import GamesSection from "@/components/GamesSection";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen relative">
      <Header />
      <main>
        <Hero />
        <TrackCards />
        <DonationSection />
        <GamesSection />
      </main>
      <Footer />
    </div>
  );
}
